import { connect } from 'react-redux';
import Pagination from 'Shared/Pagination';
import { getCurrentPage, setCurrentPage } from '../ducks';

const mapStateToProps = state => ({
  currentPage: getCurrentPage(state),
  // totalPages: totalPages || getTotalPages(state),
});

export default connect(mapStateToProps, dispatch => ({
  onPageChange: page => dispatch(setCurrentPage(page)),
}))(Pagination);
